import type { AiChatConversationContext } from '../aiChatContextTypes';

export const getConversationFocusLabel = (context?: AiChatConversationContext): string => {
  if (!context) {
    return '';
  }

  const symbol = typeof context.data.symbol === 'string' ? context.data.symbol : null;
  const name = typeof context.data.name === 'string' ? context.data.name : null;
  return symbol ?? name ?? '';
};
